import { HEAT_SELECT } from '../actions/heat';
import { ROUND_SELECT } from '../actions/round';
import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';

import oget from 'oget';

const defaultState = {
  expectedHeatId: null,
  byId: {},
  isLiveId: null,
};

let heatsById = {};

const parseAthletes = (expectedHeatId, athletesById = {}) => ({
  expectedHeatId,
  byId: athletesById,
  isLiveId: Object.keys(athletesById).filter((key) => {
    return (athletesById[key] || {}).isLive;
  })[0],
});

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case ROUND_SELECT: {
      const liveHeat = oget(payload.round, 'liveHeat', {});

      return {
        ...defaultState,
        expectedHeatId: oget(liveHeat, 'externalId', null),
      };
    }

    case HEAT_SELECT: {
      const selectedHeatId = payload.externalId;

      return parseAthletes(selectedHeatId, oget(heatsById, `${selectedHeatId}.athletesById`, {}));
    }

    case CONTESTS_SHOW_SUCCESS: {
      const { selectedHeatId } = payload;
      heatsById = payload.heatsById;

      if (state.expectedHeatId !== null && selectedHeatId !== state.expectedHeatId) {
        return state;
      }

      return parseAthletes(selectedHeatId, oget(heatsById, `${selectedHeatId}.athletesById`, {}));
    }

    default: {
      return state;
    }
  }
};
